import React from 'react';
import styles from "@styles/share.module.css"
import IconButton from '@backpack/forms/IconButton';

import { Mail, MessageCircle, Link } from 'feather-icons-react';

const ShareComponent = ({ url, title }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = [
    {
      name: 'Email',
      url: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
      icon: <Mail />,
    },
    {
      name: 'Text Message',
      url: `sms:?&body=${encodedTitle} ${url}`,
      icon: <MessageCircle />,
    },
    {
      name: 'Copy Link',
      action: () => navigator.clipboard.writeText(url),
      icon: <Link />,
    },
    {
      name: 'Facebook',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      class: styles.bgFacebook,
    },
    {
      name: 'Twitter',
      url: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      class: styles.bgTwitter,
    },
    {
      name: 'LinkedIn',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      class: styles.bgLinkedInn,
    },
    {
      name: 'WhatsApp',
      url: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      class: styles.bgWhatsapp,
    },
    {
      name: 'Telegram',
      url: `https://telegram.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
      class: styles.bgTelegram,
    },
    {
      name: 'Reddit',
      url: `https://reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`,
      class: styles.bgReddit,
    },
    {
      name: 'Pinterest',
      url: `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedTitle}`,
      class: styles.bgPinterest,
    },
  ];


  return (
    <section>
      <ul className={styles.share}>
      {shareLinks.map((link, index) => (
          <li key={index}>
            {link.icon ? (
              link.action ? (
                <IconButton onClick={link.action} title={link.name}>
                  {link.icon}
                </IconButton>
              ) : (
                <IconButton
                  component="a"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={link.name}
                >
                  {link.icon}
                </IconButton>
              )
            ) : (
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                title={link.name}
              >
                <div className={link.class} />
              </a>
            )}
          </li>
        ))}
      </ul>
      <hr />
    </section>
  );
};

export default ShareComponent;
